module.exports = __webpack_public_path__ + "media/B3.fea59632.mp3";